import { useAuth } from '../../contexts/AuthContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useLoginService = () => {
  const [modal, setModal] = useState(null);
  const navigate = useNavigate();
  const { loginWithMicrosoftFn } = useAuth();

  const handleMicrosoftLogin = async () => {
    const result = await loginWithMicrosoftFn();
    if (result.success) {
      setModal({
        type: "success",
        title: "Login Successful",
        message: "Welcome! You will be redirected to the dashboard.",
      });
      // setTimeout(() => {
      //   setModal(null);
      //   navigate("/timesheet");
      // }, 2000);
    } else {
      setModal({
        type: "error",
        title: "Login Failed",
        message: result.error || "Microsoft login failed. Please try again.",
      });
    }
  };

  const handleCloseModal = () => {
    setModal(null);
    if (modal?.type === "success") {
      navigate("/dashboard");
    }
  };

  return {
    modal,
    handleMicrosoftLogin,
    handleCloseModal
  };
}; 